import { type IGoogleConsentState } from './cookie-consent';

export type TGtagCommand = [
  command: 'consent',
  action: 'default' | 'update',
  state: IGoogleConsentState,
];

export const gtag: (...command: TGtagCommand) => void = function gtagCommand() {
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push(arguments);
};
